<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <v-sheet class="w-full">
        <i-card-vertical
          headerTitle="위험성평가 조직도 관리"
          device="multi"
          contentsClass="overflow-x-hidden overflow-y-auto pr-5"
        >
          <template v-slot:body>
            <v-tabs active-class="active_tab" v-model="selectedTab">
              <v-tabs-slider></v-tabs-slider>
              <v-tab
                class="px-2"
                v-for="item in tabs"
                :key="item.tabpageId"
                @click="clickTab"
              >{{ item.title }}</v-tab>
              <!-- /////////////////////////////////////// /* 조직구성도 탭 구성 */ /////////////////////////////////////// -->
              <v-tabs-items v-model="selectedTab" :touchless="true">
                <v-tab-item>
                  <RiskOrgnVerHistManage
                    ref="RiskOrgnVerHistManage"
                    :guide-highlight-confirm="guideHighlightConfirm"
                    @moveToTabPage="moveToTabPage"
                    @orgnVersionChanged="orgnVersionChanged"
                  ></RiskOrgnVerHistManage>
                </v-tab-item>
                <!-- /////////////////////////////////////// /* 조직구성 차수 이력 탭 구성 */ /////////////////////////////////////// -->
                <v-tab-item>
                  <RiskOrgnDetailDiagram ref="RiskOrgnDetailDiagram" @moveToTabPage="moveToTabPage"></RiskOrgnDetailDiagram>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
          </template>
          <template v-slot:drawer>
            <v-navigation-drawer
              v-model="procedureShow"
              width="75%"
              absolute
              right
              temporary
              class="feedback-area"
            >
              <ProcedureComponent :type="'00004'" />
            </v-navigation-drawer>
          </template>
        </i-card-vertical>
      </v-sheet>
      <v-sheet height="100%" class="iCardRightWrap" :key="selectedTab" :class="{ 'guide-highlight-add': guideHighlightAdd }">
        <i-card-right
          v-if="selectedTab == 0"
          :useBtnList="buttonUseListHistory"
          @btnAdd="btnAdd()"
          @btnSearch="btnSearch()"
          @btnSave="btnHistorySave()"
          @btnDelete="btnDelete()"
        ></i-card-right>
        <i-card-right
          v-else-if="selectedTab == 1"
          :useBtnList="buttonUseListOrgn"
          @btnSave="btnOrgnSave()"
          @btnCopy="btnCopy()"
          @btnEdit="btnEdit()"
        ></i-card-right>
        <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button
              color="btn_text"
              :text="'절차서'"
              :icon="'file'"
              @click="procedureShow = !procedureShow"
            ></i-icon-button>
          </template>
        </i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
//
import RiskOrgnVerHistManage from './RiskOrgnManage_VerHistory.vue'
import RiskOrgnDetailDiagram from './RiskOrgnManage_Detail.vue'
import baseview from '@/views/base/baseview.vue'
import { AesEncrypt, AesDecrypt } from '@/utils/aes256'
import iCardVertical from '@/components/common/iCardVertical.vue'
import iCardRight from '@/components/common/iCardRight.vue'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'

export default {
  mixins: [baseview],
  name: 'RiskOrgnManage',
  components: {
    'i-card-vertical': iCardVertical,
    'i-card-right': iCardRight,
    RiskOrgnVerHistManage,
    RiskOrgnDetailDiagram,
    // 절차서 컴포넌트
    ProcedureComponent
  },
  created() {},
  data() {
    return {
      initCompId: '',
      tabs: [
        { tabpageId: 'orgnVerHist', title: '차수이력' },
        { tabpageId: 'orgnDiagram', title: '위험성평가조직' }
      ],
      selectedTab: '1',
      selectedOrgnVersion: '',
      buttonUseListHistory: ['btnSearch', 'btnAdd', 'btnSave', 'btnDelete'],
      buttonUseListOrgn: [
        'btnEdit', //수정
        'btnCopy', //복사
        'btnSave' //저장
      ],
      // 절차서 컴포넌트
      procedureContent: '',
      procedureShow: false, // 절차서 보이기
      guideHighlightAdd: false, // 안전보건관리체계 구축 진행도 이동 시(데이터 없음) 추가 버튼 깜빡임
      guideHighlightConfirm: false, // 안전보건관리체계 구축 진행도 이동 시(데이터 있음) 확정여부 컬럼 깜빡임
      _guideHighlightTimer: null,
    }
  },
  computed: {},
  watch: {
    // 안전보건관리체계 구축 진행도에서 같은 경로로 재이동할 때(query._t) 가이드 하이라이트 재적용
    '$route.query._t'(val, oldVal) {
      if (val && oldVal && val !== oldVal) {
        this.applyGuideHighlightFromRoute()
      }
    },
  },
  beforeMount() {},
  mounted() {
    this.initCompId = this.getCompId() // 초기 페이지 진입 시 compId 세팅
    this.applyGuideHighlightFromRoute()
  },
  activated() {
    if (this.$route.params?.data?.guideHighlight) {
      this.applyGuideHighlightFromRoute()
    }
    if (this.changedCompFlag(this.initCompId)) {
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      this.initCompId = this.getCompId()
      this.selectedTab = '1'
      // this.btnSearch()
      this.$refs.RiskOrgnVerHistManage.btnSearch()
    }
  },
  beforeDestroy() {
    if (this._guideHighlightTimer) {
      clearTimeout(this._guideHighlightTimer)
      this._guideHighlightTimer = null
    }
  },
  methods: {
    // 안전보건관리체계 구축 진행도에서 진입 시 데이터 유무에 따라 추가/확정여부 강조
    async applyGuideHighlightFromRoute() {
      const routeData = this.$route.params && this.$route.params.data
      if (!routeData || !routeData.guideHighlight) return

      if (this._guideHighlightTimer) {
        clearTimeout(this._guideHighlightTimer)
        this._guideHighlightTimer = null
      }
      this.guideHighlightAdd = false
      this.guideHighlightConfirm = false

      // 추가·확정여부는 차수이력 탭에 있음
      this.selectedTab = 0
      await this.$nextTick()

      // lazy 탭 전환 후 컴포넌트 마운트 대기
      let hist = this.$refs.RiskOrgnVerHistManage
      for (let i = 0; !hist && i < 10; i++) {
        await new Promise((resolve) => setTimeout(resolve, 50))
        hist = this.$refs.RiskOrgnVerHistManage
      }
      if (!hist) return

      await hist.btnSearch()
      const hasData = (hist.orgnDatasource || []).length > 0

      this.$nextTick(() => {
        this.guideHighlightAdd = !hasData
        this.guideHighlightConfirm = hasData
        this._guideHighlightTimer = setTimeout(() => {
          this.guideHighlightAdd = false
          this.guideHighlightConfirm = false
          this._guideHighlightTimer = null
        }, 5000)
      })
    },
    // 차수이력
    btnAdd() {
      this.$refs.RiskOrgnVerHistManage.btnAdd()
    },
    btnSearch() {
      this.$refs.RiskOrgnVerHistManage.btnSearch()
    },
    btnHistorySave() {
      this.$refs.RiskOrgnVerHistManage.btnSave()
    },
    btnDelete() {
      this.$refs.RiskOrgnVerHistManage.btnDelete()
    },
    // 조직도
    btnOrgnSave() {
      this.$refs.RiskOrgnDetailDiagram.btnSave()
    },
    btnCopy() {
      this.$refs.RiskOrgnDetailDiagram.btnCopy()
    },
    btnEdit() {
      this.$refs.RiskOrgnDetailDiagram.btnEdit()
    },
    getSelectedRowsData() {
      return new Promise((resolve, reject) => {
        this.$refs.RiskOrgnVerHistManage.DataGrids[0].getSelectedRowsData().then(res => resolve(res))
      })
    },
    async clickTab() {
      await this.getSelectedRowsData().then(selectedRow => {
        if (selectedRow.length == 0) {
          let datasource = this.$refs.RiskOrgnVerHistManage.DataGrids[0].option('dataSource')
          if (datasource.length != 0) selectedRow = datasource
        }

        if (
          this.selectedTab == 1 &&
          (selectedRow.length < 1 || selectedRow[0].orgnOrder == undefined || selectedRow[0].orgnOrder.startsWith('insert-') == true)
        ) {
          this.vSnackbar(this.$t('조직도는 차수 저장 후 조회가능합니다.'), 'warn')
          this.selectedTab = 0
          return
        }

        console.log('clickTab', this.selectedTab, selectedRow[0].orgnOrder)
        if (this.selectedTab == 0) {
          this.$refs.RiskOrgnVerHistManage.btnSearch()
        } else {
          this.$EventBus.$emit('clickTab', selectedRow[0])
        }
      })
    },
    async moveToTabPage(orgnVer, tabIndex) {
      if (tabIndex == '0') {
        this.selectedTab = 0
        this.$refs.RiskOrgnVerHistManage.btnSearch()
      } else {
        this.selectedTab = 1
        await this.getSelectedRowsData().then(selectedRow => {
          if (selectedRow[0].orgnOrder == undefined || selectedRow[0].orgnOrder.startsWith('insert-') == true) {
            this.selectedTab = 0
            this.vSnackbar(this.$t('조직도는 차수 저장 후 조회가능합니다.'), 'warn')
            return
          }
          this.$EventBus.$emit('moveToTabPage', selectedRow[0])
        })
      }

      // this.selectedOrgnVersion = orgnVer
      // console.log('moveToTabPage ' + orgnVer)
      // this.$EventBus.$emit('moveToTabPage', orgnVer)
    },
    orgnVersionChanged() {
      console.log('OnsaveAndDeleteMaster')
      this.$EventBus.$emit('OnsaveAndDeleteMaster', this.selectedOrgnVersion)
    }
  }
}
</script>
<style lang="scss">
.iCardRightWrap {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.mobile .iCardRightWrap {
  flex-direction: row;
}

@keyframes guide-blink-red {
  0%,
  100% {
    color: inherit;
    box-shadow: inset 0 0 0 0 transparent;
    outline: 2px solid transparent;
    background-color: transparent;
  }
  50% {
    color: #f44336 !important;
    box-shadow: inset 0 0 0 2px rgba(244, 67, 54, 0.85);
    outline: 2px solid #f44336;
    background-color: rgba(244, 67, 54, 0.12);
  }
}

.guide-highlight-add .btn_btnAdd {
  animation: guide-blink-red 0.8s ease-in-out 5;
  border-radius: 8px;
}

/* 확정여부 컬럼: 헤더만 강조 */
.dx-datagrid-headers .guide-blink-target {
  animation: guide-blink-red 0.8s ease-in-out 5;
  border-radius: 8px;
}
</style>
